import { render } from "./InputTelephoneWithExt.vue?vue&type=template&id=00083e19"
import script from "./InputTelephoneWithExt.vue?vue&type=script&lang=js"
export * from "./InputTelephoneWithExt.vue?vue&type=script&lang=js"

import "./InputTelephoneWithExt.vue?vue&type=style&index=0&id=00083e19&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__